/**
 * record-procedures/error-keys — mapowanie kodów błędów backendu (walidacja strukturalna SQL +
 * egzekutor) na klucze i18n czytelnych komunikatów.
 *
 * Współdzielony przez `RecordProcedureFormModal.tsx` (sekcja „Testuj", `POST
 * .../test-sql`) i `RecordProceduresTab.tsx` (create/update — te same kody `SQL_<code>` /
 * `VALIDATION_FAILED` mogą wrócić z `POST`/`PATCH .../record-procedures`, bo obie trasy
 * wołają ten sam walidator strukturalny PRZED zapisem — mirror kontraktu backendu,
 * `apps/api/lib/dictionaries/sql-source-validator.ts` + `apps/api/lib/record-hooks/`).
 */

export function testSqlErrorKey(code: string | undefined): string {
  switch (code) {
    case 'SQL_NOT_SELECT':
      return 'recordProcedures.form.sqlErrors.notSelect';
    case 'SQL_MULTIPLE_STATEMENTS':
      return 'recordProcedures.form.sqlErrors.multipleStatements';
    case 'SQL_PARAM_UNDECLARED':
      return 'recordProcedures.form.sqlErrors.paramUndeclared';
    case 'SQL_EMPTY':
      return 'recordProcedures.form.sqlErrors.empty';
    case 'SQL_FORBIDDEN_KEYWORD':
      return 'recordProcedures.form.sqlErrors.forbiddenKeyword';
    case 'SQL_UNSUPPORTED_SYNTAX':
      return 'recordProcedures.form.sqlErrors.unsupportedSyntax';
    case 'EXTERNAL_PARAM_MISSING':
      return 'recordProcedures.form.sqlErrors.paramMissing';
    case 'EXTERNAL_PARAM_INVALID':
      return 'recordProcedures.form.sqlErrors.paramInvalid';
    case 'RECORD_PROCEDURE_RESULT_SHAPE':
      return 'recordProcedures.form.sqlErrors.resultShape';
    case 'EXECUTION_FAILED':
      return 'recordProcedures.form.sqlErrors.executionFailed';
    case 'TIMEOUT_NOT_ALLOWED':
      // PATCH z `timeoutMinutes` dla procedury innej niż „Na przycisk" (400) — formularz tego nie
      // wysyła, ale kod jest częścią kontraktu trasy.
      return 'recordProcedures.form.sqlErrors.timeoutNotAllowed';
    case 'PARAMS_NOT_ALLOWED':
      // PATCH procedury „Na przycisk" z niepustą listą parametrów (400) — przycisk ma wyłącznie
      // parametry systemowe; formularz zawsze wysyła pustą listę, ale kod jest częścią kontraktu.
      return 'recordProcedures.form.sqlErrors.paramsNotAllowed';
    default:
      // Obejmuje też `VALIDATION_FAILED` (422 Zod na create/update, `Tab` onError) — rzadki
      // przypadek (walidacja klienta pokrywa pola po stronie UI), bez dedykowanego klucza.
      return 'recordProcedures.form.sqlErrors.generic';
  }
}
